import React, { useState, useEffect } from 'react';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PublicLayout from './components/PublicLayout';
import Home from './pages/Home';
import RenovationEnergetique from './pages/RenovationEnergetique';
import Realisations from './pages/Realisations';
import Partenaires from './pages/Partenaires';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import ServicePage from './pages/ServicePage';
import LocalPage from './pages/LocalPage';
import { SERVICES } from './data/services';
import { CITIES } from './data/cities';
import { ARRONDISSEMENTS } from './data/arrondissements';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import { Toaster } from './components/ui/sonner';

function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const checkAuth = async () => {
      // Only probe the session on admin routes to avoid noisy 401s on public pages
      if (!window.location.pathname.startsWith('/admin')) {
        setAuthLoading(false);
        return;
      }
      try {
        const response = await fetch(`${API_URL}/api/auth/me`, {
          credentials: 'include'
        });
        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        }
      } catch (error) {
        console.log('Not authenticated');
      } finally {
        setAuthLoading(false);
      }
    };
    checkAuth();
  }, [API_URL]);

  const handleLogin = (userData) => setUser(userData);
  const handleLogout = () => setUser(null);

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/renovation-energetique" element={<RenovationEnergetique />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/partenaires-professionnels" element={<Partenaires />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            {SERVICES.map((s) => (
              <Route key={s.slug} path={s.path} element={<ServicePage data={s} />} />
            ))}
            {CITIES.map((c) => (
              <Route key={c.slug} path={c.path} element={<LocalPage data={c} />} />
            ))}
            {ARRONDISSEMENTS.map((a) => (
              <Route key={a.slug} path={a.path} element={<LocalPage data={a} />} />
            ))}
          </Route>

          <Route
            path="/admin/login"
            element={
              user ? (
                <Navigate to="/admin/dashboard" replace />
              ) : (
                <AdminLogin onLogin={handleLogin} />
              )
            }
          />

          <Route
            path="/admin/dashboard"
            element={
              user && user.role === 'admin' ? (
                <AdminDashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/admin/login" replace />
              )
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
    </HelmetProvider>
  );
}

export default App;
